<div class="alt-row-between">
  <p class="alt-inter-bold alt-size-20 " >{{"COMPANY.pre-register-company" | translate }}</p>
  <mat-icon class="pointer" svgIcon="crossMenu" (click)="closeModal()" ></mat-icon>
</div>

<p class="create-main-text  alt-inter-medium alt-size-16 " >{{"FACILITATOR.made-or-charge" | translate}}</p>

<div class="btn-charge-container alt-column-align-center">
  <button class="btn-excel create-button pointer" mat-button type="button" (click)="openMasiveCharge()" >
    {{"FACILITATOR.charge-data" | translate | uppercase }}
  </button>
  <button class="btn-manually charge-button pointer" mat-button type="button" (click)="goToPreRegister()">
    {{"FACILITATOR.charge-manually" | translate | uppercase }}
  </button>
</div>

